import { render, staticRenderFns } from "./LaneClosureRequestBlockSidewalkListing.vue?vue&type=template&id=04327e08&"
import script from "./LaneClosureRequestBlockSidewalkListing.vue?vue&type=script&lang=js&"
export * from "./LaneClosureRequestBlockSidewalkListing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports